import { mergePaths } from '@cian/http-api/shared';

const isApiRequest = function (url, apiPath) {
  return (
    url.indexOf(apiPath) === -1 &&
    url.indexOf('.html') === -1 &&
    url.indexOf('.jade') === -1 &&
    !url.startsWith('http') &&
    !url.startsWith('//')
  );
};

const isRootRequest = url => {
  return url.startsWith('/') && !url.startsWith('//');
};

export default [
  'config',
  config => {
    return {
      request(requestConfig) {
        const isApiReq = isApiRequest(requestConfig.url, '/addform/v2/');
        const isRootReq = isRootRequest(requestConfig.url);
        const apiBaseUrl = config.get('addformConfig.baseApiUrl');

        if (isRootReq) {
          requestConfig.url = mergePaths(apiBaseUrl, requestConfig.url);
        } else if (isApiReq) {
          requestConfig.url = mergePaths(apiBaseUrl, mergePaths('/addform/v2/', requestConfig.url));
        }

        return requestConfig;
      },
    };
  },
];
